import geofencesActions from '@state/geofences/actions';
import * as defaultAlarms from '@pages/Alertas/helpers/defaultAlerts/alertsNames';

import constants from './constants';

const initOrCondition = {
  type: 'equality',
  field: '',
};

function setIsEditDefault({ name, forceIsEdit = null } = {}) {

  const isEditDefault = Object.values(defaultAlarms).includes(name);
  return {
    type: constants.SET_IS_EDIT_DEFAULT,
    payload: forceIsEdit === null ? isEditDefault : forceIsEdit,
  };

}

function setCreateEditValues(values) {

  return {
    type: constants.SET_CREATE_EDIT_VALUES,
    payload: values,
  };

}

function addCreateEditValuesGroupConditions() {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions, []];
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS,
      payload: newCreateEditValues,
    });

  };

}

function removeCreateEditValuesGroupConditions(index) {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions.splice(index, 1);
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS,
      payload: newCreateEditValues,
    });

  };

}

function addOrCondition(index, values = initOrCondition) {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions[index] = [...newConditions[index], values];
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.ADD_CREATE_EDIT_VALUES_OR_CONDITION,
      payload: newCreateEditValues,
    });

  };

}

function removeOrCondition(groupIndex, conditionIndex) {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions[groupIndex].splice(conditionIndex, 1);
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION,
      payload: newCreateEditValues,
    });

  };

}

function changeOrCondition(groupIndex, conditionIndex, values) {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions[groupIndex][conditionIndex] = values;
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION,
      payload: newCreateEditValues,
    });

  };

}

function addCreateEditValuesAction(initAction) {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { actions } = createEditValues;
    if (actions === undefined) return;

    const newActions = [...actions, initAction];
    const newCreateEditValues = { ...createEditValues, actions: newActions };

    dispatch({
      type: constants.ADD_CREATE_EDIT_VALUES_ACTION,
      payload: newCreateEditValues,
    });

  };

}

function removeCreateEditValuesAction(index) {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { actions } = createEditValues;
    if (actions === undefined) return;

    const newActions = [...actions];
    newActions.splice(index, 1);
    const newCreateEditValues = { ...createEditValues, actions: newActions };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_ACTION,
      payload: newCreateEditValues,
    });

  };

}

function changeCreateEditValuesAction(index, values) {

  return (dispatch, getState) => {

    const {
      inverters: { createEditValues },
    } = getState();

    const { actions } = createEditValues;
    if (actions === undefined) return;

    const newActions = [...actions];
    newActions[index] = values;
    const newCreateEditValues = { ...createEditValues, actions: newActions };

    dispatch({
      type: constants.CHANGE_CREATE_EDIT_VALUES_ACTION,
      payload: newCreateEditValues,
    });

  };

}

function setAlarmsList({ count, results, preventAppend = false } = {}) {

  return (dispatch, getState) => {

    const { offset, invertersList, limit } = getState().inverters;
    const newOffset = offset + limit;
    const newAlarmsList = invertersList && offset !== 0 ? [...invertersList, ...results] : results;
    dispatch({
      type: constants.SET_ALARMS_LIST,
      payload: {
        offset: newOffset,
        invertersList: newAlarmsList,
        count,
      },
    });

  };

}

function addAlarmToListOrSumCount(newAlarm) {

  return (dispatch, getState) => {

    const { invertersList, count, search } = getState().inverters;
    if (!count) return;

    dispatch(geofencesActions.resetState());

    if (search.length > 0) {

      dispatch({ type: constants.RESET_ALARMS });
      return;

    }

    const isFull = invertersList ? invertersList.length === count : false;
    const newCount = count + 1;

    if (isFull) {

      const newAlarmsList = [...invertersList, newAlarm];

      dispatch({
        type: constants.ADD_ALARM,
        payload: {
          invertersList: newAlarmsList,
          count: newCount,
        },
      });

      return;

    }

    dispatch({
      type: constants.SET_ALARM_COUNT,
      payload: newCount,
    });

  };

}

function editAlarm(editedAlarm) {

  return (dispatch, getState) => {

    const { invertersList } = getState().inverters;
    if (!invertersList) return;

    const alarmToEditIndex = invertersList.findIndex((alarm) => alarm.id === editedAlarm.id);
    if (alarmToEditIndex === -1) return;

    const newAlarmsList = [...invertersList];
    newAlarmsList[alarmToEditIndex] = editedAlarm;

    dispatch(geofencesActions.resetState());

    dispatch({
      type: constants.EDIT_ALARM,
      payload: newAlarmsList,
    });

  };

}

function startDeletingAlarm(id) {

  return (dispatch, getState) => {

    const { idsInDeleting } = getState().inverters;
    const newIdsInDeleting = [...idsInDeleting, id];
    dispatch({
      type: constants.START_DELETING_ALARM,
      payload: newIdsInDeleting,
    });

  };

}

function deleteAlarm(id) {

  return (dispatch, getState) => {

    const { invertersList, count, idsInDeleting } = getState().inverters;
    if (!invertersList) return;

    const alarmIndex = invertersList.findIndex((alarm) => alarm.id === id);
    const deleteIndex = idsInDeleting.indexOf(id);

    if (alarmIndex === -1) return;

    const newAlarmsList = [...invertersList];
    newAlarmsList.splice(alarmIndex, 1);
    const newCount = count ? count - 1 : count;

    const newIdsInDeleting = idsInDeleting.slice();
    if (deleteIndex !== -1) newIdsInDeleting.splice(deleteIndex, 1);

    dispatch(geofencesActions.resetState());

    dispatch({
      type: constants.DELETE_ALARM,
      payload: {
        invertersList: newAlarmsList,
        count: newCount,
        idsInDeleting: newIdsInDeleting,
      },
    });

  };

}

function resetOffset() {

  return { type: constants.RESET_OFFSET };

}

function setSearch(value) {

  return { type: constants.SET_SEARCH, payload: value };

}

const setCreateEditDevice = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CREATE_EDIT_DEVICES,
    payload: values,
  });

};

const setGetListModelInverters = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_GET_MODEL_INVERTERS,
    payload: values,
  });

};

const setInventerIdEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_INVERTER_ID_TO_EDIT,
    payload: values,
  });

};

const setEditInverterData = (dataInverter) => (dispatch) => {

  dispatch({
    type: constants.SET_INVERTER_EDIT_DATA,
    payload: dataInverter,
  });
  // return (dispatch, getState) => {

  //   const { telemetry } = getState();
  //   const { allInverters } = telemetry;
  //   const indexTarget = allInverters.filter((data) => data.id === idInverter);
  //   if (indexTarget) {

  //     dispatch({
  //       type: constants.SET_INVERTER_EDIT_DATA,
  //       payload: indexTarget[0],
  //     });

  //   }

  // };

};

const setSaveState = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_SABE_STATE,
    payload: values,
  });

};

export default {
  setIsEditDefault,
  setCreateEditValues,
  addCreateEditValuesGroupConditions,
  removeCreateEditValuesGroupConditions,
  addOrCondition,
  removeOrCondition,
  changeOrCondition,
  addCreateEditValuesAction,
  removeCreateEditValuesAction,
  changeCreateEditValuesAction,
  setAlarmsList,
  addAlarmToListOrSumCount,
  editAlarm,
  deleteAlarm,
  resetOffset,
  setSearch,
  startDeletingAlarm,
  setCreateEditDevice,
  setGetListModelInverters,
  setInventerIdEdit,
  setEditInverterData,
  setSaveState,
};
